import { TicketRoutePaths } from '../interfaces/Routes';
import { Ticket } from '../interfaces/Ticket';
import StepsService from './StepsService';

export enum InitType {
  cancel = 'c',
  signature = 'sign',
  ticket = 't'
}

interface CalculateInitialPageParams {
  ticket: Ticket;
}

const calculateInitialPage = ({ ticket }: CalculateInitialPageParams): string | null => {
  const selfserviceFlowStatuses = ['Dispatched', 'In Progress', 'On Route', 'Completed', 'New', 'Execution On Hold'];

  if (selfserviceFlowStatuses.includes(ticket.workOrder.status)) {
    const steps = StepsService.getDefaultSteps(ticket);
    const activeStep = StepsService.getActiveStep(steps);

    return activeStep.uri;
  }

  return null;
};

const isPathInRoutes = (path: string, routes: TicketRoutePaths[]): boolean => {
  return routes.some(route => path.includes(`/${route}`));
};

export { calculateInitialPage, isPathInRoutes };
